import history from '../history';

const EXTERNAL_URL_REGEX = /^(https?:)?\/\//i;

// `options.state` viaja con la navegación (queda en `location.state` de la pantalla de destino)
// y no en la URL: es para llegar con un aviso que no tiene por qué quedar en un link copiado.
export const navigateTo = (target, options = {}) => {
    if (!target) {
        return;
    }

    if (EXTERNAL_URL_REGEX.test(target)) {
        window.location.href = target;
        return;
    }

    if (options.replace) {
        history.replace(target, options.state);
        return;
    }

    history.push(target, options.state);
};

export const getCurrentPath = () => {
    const { pathname, search, hash } = history.location;
    return `${pathname || ''}${search || ''}${hash || ''}`;
};
